import { useEffect, useState } from "react";
import Button from "../../Custom/Button/Button";
import { useGlobalContext } from "../../../Context/Context";
import CustomSelectSimple from "../Documents/evidencije/CustomSelectSimple";

const brojZaposlenihOptions = [
  "0-5",
  "5-10",
  "10-50",
  "50-100",
  "100-1000",
  ">1000"
];

const styles = {
  button: {
    padding: "10px 20px"
  },
  divInput: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minWidth: 0
  },
  label: {
    fontSize: "16px",
    fontWeight: "bold",
    marginLeft: "7px"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "5px"
  },
  input: {
    padding: "5px",
    fontSize: "16px",
    height: "unset",
    minWidth: 0
  },
  btnContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "7px",
    alignItems: "center"
  }
};

const emptyData = {
  company_name: "",
  company_address: "",
  pib: "",
  working_name: "",
  number_of_employees: "",
  activity_code: "",
  registration_number: ""
};

const numberRegex = /^\d*$/;

const DodavanjeKlijenta = ({ azuriranjeId, handleCancel }) => {
  const [data, setData] = useState(emptyData);

  const {
    dictionary,
    selectedCompany,
    loggedUser,
    setSelectedCompany,
    baseUrl
  } = useGlobalContext();

  const fetchCompany = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/companies/read_single.php?id=${azuriranjeId}`
      );

      const result = await response.json();

      if (result.status === 200) {
        setData(result.data);
      } else {
        alert("Server greška: " + result.message);
      }
    } catch (error) {
      alert("Serverska greška pri slanju.");
    }
  };

  useEffect(() => {
    if (azuriranjeId) fetchCompany();
    else setData(emptyData);
  }, [azuriranjeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (
      ["registration_number", "pib"].includes(name) &&
      (!numberRegex.test(value) || value.length > 9)
    )
      return;

    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeBrojZaposlenih = (newValue) => {
    setData((prev) => ({ ...prev, number_of_employees: newValue }));
  };

  const handleSave = async () => {
    try {
      const response = await fetch(`${baseUrl}/companies/createFull.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          company_name: data.company_name,
          company_address: data.company_address,
          pib: data.pib,
          parent_id: selectedCompany.company_id,
          user_id: loggedUser.id,
          working_name: data.working_name,
          registration_number: data.registration_number,
          activity_code: data.activity_code,
          number_of_employees: data.number_of_employees
        })
      });

      const result = await response.json();

      if (result.status === 200) {
        setSelectedCompany((prev) => ({
          ...prev,
          accounts: [
            ...prev.accounts,
            { ...data, company_id: result.company_id }
          ]
        }));
        handleCancel();
      } else {
        alert("Server greška: " + result.message);
      }
    } catch (error) {
      alert("Serverska greška pri slanju.");
    }
  };

  const handleUpdate = async () => {
    try {
      const response = await fetch(`${baseUrl}/companies/updateFull.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          company_id: azuriranjeId,
          company_name: data.company_name,
          company_address: data.company_address,
          pib: data.pib,
          working_name: data.working_name,
          registration_number: data.registration_number,
          activity_code: data.activity_code,
          number_of_employees: data.number_of_employees
        })
      });

      const result = await response.json();

      if (result.status === 200) {
        setSelectedCompany((prev) => ({
          ...prev,
          accounts: prev.accounts.map((account) =>
            account.company_id == azuriranjeId
              ? { ...account, ...data }
              : account
          )
        }));
        handleCancel();
      } else {
        alert("Server greška: " + result.message);
      }
    } catch (error) {
      alert("Serverska greška pri slanju.");
    }
  };

  const isSaveDisabled =
    !data.company_name ||
    !data.company_address ||
    data.pib.length !== 9 ||
    !data.working_name ||
    !data.number_of_employees ||
    !data.activity_code ||
    !data.registration_number;

  return (
    <div style={styles.container}>
      <div style={styles.divInput}>
        <div style={styles.label}>{dictionary["radniNaziv"]}</div>
        <input
          name="working_name"
          value={data.working_name}
          onChange={handleChange}
          style={styles.input}
        />
      </div>
      <div style={styles.divInput}>
        <div style={styles.label}>{dictionary["poslovnoIme"]}</div>
        <input
          name="company_name"
          value={data.company_name}
          onChange={handleChange}
          style={styles.input}
        />
      </div>
      <div style={styles.divInput}>
        <div style={styles.label}>{dictionary["adresaSedista"]}</div>
        <input
          name="company_address"
          value={data.company_address}
          onChange={handleChange}
          style={styles.input}
        />
      </div>

      <div style={styles.divInput}>
        <div style={styles.label}>
          {dictionary["brZaposlenihSifDelatnosti"]}
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <div style={{ flex: 1 }}>
            <CustomSelectSimple
              allValues={brojZaposlenihOptions}
              selectedValue={data.number_of_employees}
              onSelectChange={handleChangeBrojZaposlenih}
            />
          </div>
          <input
            name="activity_code"
            value={data.activity_code}
            onChange={handleChange}
            style={{ ...styles.input, flex: 1 }}
          />
        </div>
      </div>

      <div style={{ display: "flex", gap: "10px", width: "100%" }}>
        <div style={{ ...styles.divInput, flex: 1 }}>
          <div style={styles.label}>{dictionary["pib"]}</div>
          <input
            name="pib"
            value={data.pib}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
        <div style={{ ...styles.divInput, flex: 1 }}>
          <div style={styles.label}>{dictionary["matBr"]}</div>
          <input
            name="registration_number"
            value={data.registration_number}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
      </div>

      <div style={styles.btnContainer}>
        <div
          onClick={azuriranjeId ? handleUpdate : handleSave}
          style={{
            opacity: isSaveDisabled ? 0.5 : 1,
            width: "90%",
            height: "40px"
          }}
        >
          <Button
            isDisabled={isSaveDisabled}
            activation={true}
            style={styles.button}
          >
            <span style={{ fontWeight: "bold" }}>{dictionary["sacuvaj"]}</span>
          </Button>
        </div>
        <div onClick={handleCancel} style={{ width: "90%", height: "40px" }}>
          <Button activation={true} style={styles.button}>
            <span style={{ fontWeight: "bold" }}>{dictionary["odustani"]}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DodavanjeKlijenta;
